module.exports = __webpack_public_path__ + "img/th.780c1f60.png";